/**
 * 单品进销存查询模块接口列表
 */
import Vue from "vue"
import axios from '@/utils/http'; // 导入http中创建的axios实例
const itemSalesStock = {
    //页面初始化
    init() {
      return axios.get(`${Vue.prototype.$base.API_PATH}/item/inittemplate`);
    },
    //得到单品进销存查询数据集合
    list(params) {
      return axios.get(`${Vue.prototype.$base.API_PATH}/item/list`, { params: params});
    },
    //得到单品进销存查询获取日期title
    getDate(params) {
      return axios.get(`${Vue.prototype.$base.API_PATH}/item/date`, { params: params});
    },
}

export default itemSalesStock;



// WEBPACK FOOTER //
// ./src/api/itemSalesStock.js